const messages = {
  hours: "horas",
  minutes: "minutos",
  eta: "Previsão de chegada",
  details: "Ver detalhes",
  headline: "Acompanhe o motorista",
  omw: "O motorista está a caminho",
  finished: "O motorista chegou no local",
  destiny: "Destino",
  driver_info: "Informações do veículo",
  share: "Compartilhe essa página:",
  link_not_copied: "Copiar Link",
  link_copied: "Link Copiado",
  whatsapp: "WhatsApp",
  driver: "Motorista",
  unknown_driver: "Sem motorista",
  plate: "Placa do veículo",
  unknown_plate: "Sem placa",
  warning:
    "Por motivos de segurança, as informações dessa página expiram após o veículo " +
    "chegar no local previsto ou após 24 horas.",
  cta: "Conhecer mais",
  arrived: "O motorista chegou ao local às",
  approx_time: "hora aproximada"
};

export default messages;
